import { render } from "./VideoBlock.vue?vue&type=template&id=18187f39&scoped=true"
import script from "./VideoBlock.vue?vue&type=script&lang=js"
export * from "./VideoBlock.vue?vue&type=script&lang=js"

import "./VideoBlock.vue?vue&type=style&index=0&id=18187f39&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18187f39"],['__file',"src/vue/components/VideoBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "18187f39"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('18187f39', __exports__)) {
    api.reload('18187f39', __exports__)
  }
  
  module.hot.accept("./VideoBlock.vue?vue&type=template&id=18187f39&scoped=true", () => {
    api.rerender('18187f39', render)
  })

}


export default __exports__